<template>
  <div id="filesAdd">
     <v-container class="pa-0">
      <v-layout style="min-height:70px;">
      <v-flex md6>
        <v-btn fab absolute to="/admin/helpFiles" class="ml-3 pf-btn-fab">
          <v-icon>arrow_back</v-icon>
        </v-btn>
         </v-flex>
        <v-flex offset-md1 md5 v-if="selectedData">
        <div style="float:right">
          <v-btn class="pf-btn pf-btn-cancel" to="/admin/helpFiles">
            <v-icon size="16" class="pr-1">cancel</v-icon>
            <div>Cancel</div>
          </v-btn>
          <v-btn class="pf-btn pf-btn-save" @click="save">
            <v-icon size="16" class="pr-1">check_circle</v-icon>
            <div>Save</div>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
     </v-container>
    <v-form ref="fileAdd">
      <v-container>
        <v-layout wrap row>
            <v-flex class="xs12 sm6 md7">
                <v-text-field 
                    label="File Name" 
                    v-model.trim="fileName" 
                    class="required pr-4 pl-4"
                    :rules="fileNameRules"
                    @input="changedData"></v-text-field>
            </v-flex>
            <v-flex class="xs12 sm6 md7">
                <v-select @change="changedData($event)" multiple small-chips deletable-chips :rules="membershipRules" v-model="membership" :items="membershipList" label="Membership" class="required pr-4 pl-4" required></v-select>
            </v-flex>
        <v-flex class="xs12 sm6 md7">
            <upload-btn @file-update="fileSelected($event)" ripple noTitleUpdate :title="title" maxWidth="200px">
            <template slot="icon">
                <v-icon right dark>cloud_upload</v-icon>
            </template>
            <template slot="text-field"></template>
            </upload-btn>
        </v-flex>
      </v-layout>
      </v-container>
    </v-form>
      <v-layout class="editor-button-container">
        <v-flex xs12 class="button-container text-xs-right" v-if="selectedData">
          <div class="d-inline-flex">
            <v-btn class="pf-btn pf-btn-cancel" to="/admin/helpFiles">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
            <v-btn class="pf-btn pf-btn-save" @click="save">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>Save</div>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
  </div>
</template>

<script>
/* global session store config */  
import { getCollection, remove, uploadFile, formatDate } from '../../helpers/helpers';
import UploadButton from 'vuetify-upload-button';
import swal from 'sweetalert2';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { file } from '@babel/types';

export default {
  name: 'HelpfilesAdd',
  components: {
    'upload-btn': UploadButton,
  },  
  data: () => ({
    entity: 'HelpFile',
    title: 'Select File',
    fileName: '',
    extraParams: {},
    uploadingFile: {},
    helpFiles: [],
    membershipList: [
      'Network',
      'Featured',
      'Preferred'
    ],
    config: config,
    selectedData: false,
    membership: ['Featured'],
    membershipRules: [
      v => v.length > 0 || 'membership is required'
    ],
    fileNameRules: [
      v => !!v || 'File name is required'
    ],
  }),
  computed: {
    helpFileList: {
      get () {
        return store.state.HelpFileList;
      },
      set (value) {
        store.commit('setHelpFileList', value);
      }
    },
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  created () {
    window.getApp.$emit('pageSubHeader', 'Add');
    this.getHelpFiles();
  },
  methods: {
    async getHelpFiles () {
      if (!this.helpFileList.length) {
        let { error, data } = await getCollection(this.entity, true);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.helpFileList = data;
          }
        }
      }
    },
    async fileSelected (files) {
      this.selectedData = true;
      this.uploadingFile = files;
      let type = '';
      if (this.uploadingFile) {
        type = /[^.]+$/.exec(this.uploadingFile.name).pop();
      }
      if (type === 'docx' || type === 'pdf') {
        this.title = this.uploadingFile.name;
      } else {
        this.title = 'Select File';
        this.uploadingFile = {};
        swal.fire({
          title: `<strong>Invalid Format</strong>`,
          type: 'error',
          html: `upload "pdf" or "docx" files`,
          showCloseButton: true,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonText: 'Close',
        });
        return;
      }
    },
    async save () {
      if (!this.uploadingFile.name) {
        swal.fire({
          title: `<strong>Upload error</strong>`,
          type: 'error',
          html: 'File is required',
          showCloseButton: true,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonText: 'Close',
        });
        return;
      }
      if (this.$refs.fileAdd.validate()) {
        this.selectedData = false;
        let files = this.uploadingFile;
        if (files.size > this.config.uploadFileSize) {
          swal.fire({
            title: `<strong>Upload error</strong>`,
            type: 'error',
            html: 'Maximum file upload size is ' + (this.config.uploadFileSize / 1024 / 1024) + ' MB',
            showCloseButton: true,
            showCancelButton: false,
            focusConfirm: false,
            confirmButtonText: 'Close',
          });
          this.selectedData = true;
          return;
        }
        window.getApp.$emit('AppProgress', true);
        const fr = new FileReader();
        fr.readAsDataURL(files);
        fr.addEventListener('load', async () => {
          let length = 0;
          if (this.helpFileList.length) {
            length = Math.max.apply(null, this.helpFileList.map(item => item.sort_no));
          }
          this.extraParams = {
            name: this.fileName,
            membership: this.membership.join(','),
            sort_no: length + 1
          };
          let postUrl = 'HelpFile';
          let response = await uploadFile(postUrl, files, 'POST', this.extraParams);
          if (!response.$data) {
            window.getApp.$emit('AppProgress', false);
            console.log('error', response.$error);
            this.selectedData = true;
            this.snackbar = {
              show: true,
              color: 'red',
              text: response.$error
            };
          } else {
            this.helpFileList.push(response.$data);
            swal.fire({
              type: 'success',
              title: 'File uploaded successfully',
              showConfirmButton: false,
              timer: 2500,
              onClose: () => {
                window.getApp.$emit('AppProgress', false);
                this.$router.push({ path: '/admin/helpFiles' });
              }
            });
          }
        });
      }
    },
    changedData () {
      this.selectedData = true;
    }
  }
};
</script>

<style lang="css" scoped>
  .editor-button-container{
    padding-top: 70px;
  }
  #filesAdd >>> .primary {
    background-color: #7ac142 !important;
    border-color:#7ac142 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/Files/AdminFilesAdd.vue